import classed from "classed-components"

export const H1  = classed.div(`text-6xl font-display leading-normal mt-0 mb-2`)
export const H2 = classed.div(`text-5xl font-display leading-normal mt-0 mb-2`)
export const H3 = classed.div(`text-4xl font-display leading-normal mt-0 mb-2`)
export const H4 = classed.div(`text-3xl font-display leading-normal mt-0 mb-2`)
export const H5 = classed.div(`text-2xl font-display leading-normal mt-0 mb-2`)
export const H6 = classed.div(`text-xl font-display leading-normal mt-0 mb-2`)
